<template>
	<div class="b-dropdown" :class="classes" v-click-outside="handleClickOutside">
		<button
			class="b-dropdown__toggle"
			ref="toggle"
			@click="handleToggleClick"
			tabindex="0"
		>
			<slot name="toggle"> </slot>
		</button>

		<div ref="menu" class="b-dropdown__menu">
			<slot> </slot>
		</div>
	</div>
</template>

<script>
import { computePosition, flip, offset } from "@floating-ui/dom";
import clickOutside from "@/directives/click-outside";

export default {
	directives: {
		clickOutside,
	},
	props: {
		closeOnItemClick: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			isMenuOpen: false,
			boundUpdateMenuPosition: null,
		};
	},
	computed: {
		classes() {
			return {
				"is-open": this.isMenuOpen,
			};
		},
	},
	methods: {
		handleToggleClick() {
			if (!this.isMenuOpen) {
				this.updateMenuPosition();
				this.isMenuOpen = true;
			} else {
				this.isMenuOpen = false;
			}
		},
		handleClickOutside() {
			this.isMenuOpen = false;
		},
		handleMenuItemClick(e, id) {
			this.isMenuOpen = false;
		},
		updateMenuPosition() {
			const toggle = this.$refs.toggle;
			const menu = this.$refs.menu;

			computePosition(toggle, menu, {
				placement: "bottom-end",
				middleware: [offset(10), flip()],
			}).then(({ x, y }) => {
				Object.assign(menu.style, {
					left: `${x}px`,
					top: `${y}px`,
				});
			});
		},
	},
	created() {
		this.$on("item-click", () => {
			if (this.closeOnItemClick) {
				this.isMenuOpen = false;
			}
		});

		this.boundUpdateMenuPosition = this.updateMenuPosition.bind(this);
		window.addEventListener("resize", this.boundUpdateMenuPosition);
		window.addEventListener("scroll", this.boundUpdateMenuPosition);
	},
	destroyed() {
		window.removeEventListener("resize", this.boundUpdateMenuPosition);
		window.removeEventListener("scroll", this.boundUpdateMenuPosition);
	},
};
</script>

<style lang="scss">
.b-dropdown {
	--border-radius: 8px;
	position: relative;
}

.b-dropdown__toggle {
	cursor: pointer;
}

.b-dropdown__menu {
	position: absolute;
	z-index: 100;
	visibility: hidden;
	opacity: 0;
	background-color: #fff;
	border-radius: var(--border-radius);
	overflow: hidden;
	min-width: 285px;
}

.b-dropdown.is-open {
	.b-dropdown__menu {
		visibility: visible;
		opacity: 1;
	}
}

.b-dropdown__item {
	padding: 12px 16px;
	cursor: pointer;
	color: var(--color-neutral-600);

	&:hover {
		background-color: var(--color-neutral-25);
	}
}
</style>
